<template>
    <div>

        <loading v-show="loading"></loading>

        <div v-if="!loading">
            <div v-for="region in menu.regions" class="bg-white mb-8 shadow rounded">
                <h2 class="pl-8 py-4 text-xl">{{ region.name}}</h2>
                <ul class="list-reset">
                    <li class="border-t" v-for="theme in region.themes">
                        <a @click="$emit('folder', theme.id, 'root')"
                           class="cursor-pointer px-2 lg:px-8 hover:bg-blue-lighter py-4 text-black no-underline block flex">
                            <div class="text-lg">
                                <i class="fa fa-fw fa-caret-right text-grey"></i>
                                <i class="fa fa-fw fa-folder text-blue-dark"></i>
                                {{ theme.translations.en }}
                            </div>

                        </a>
                    </li>
                </ul>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "LibraryMenu",

        data() {
            return {
                loading: true,
                menu: {
                    regions: [],
                },
            }
        },

        created() {
            this.load();
        },

        methods: {
            load() {
                this.loading = true;
                let that = this;
                http.get('/api/v1/sources').then((response) => {
                    that.menu.regions = response.data.regions;
                    that.loading = false;
                });
            }
        }
    }
</script>

<style scoped>

</style>
